import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../../helpers/utils';

type SlideShowButtonProps = {
  className?: string;
  direction: 'next' | 'prev';
  onClick: () => void;
}

const SlideShowButton = ({ className, direction, onClick }: SlideShowButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'media-slideshow__button',
        direction === 'prev' ? 'pl-12 pr-4 -left-10' : 'pl-4 pr-12 -right-10',
        className,
      )}
      aria-label={direction === 'prev' ? 'Vorige' : 'Volgende'}
    >
      <FontAwesomeIcon
        className="text-2xl"
        icon={
          direction == 'prev'
            ? faChevronLeft as IconProp
            : faChevronRight as IconProp
        }
      />
    </button>
  );
};

export default SlideShowButton;